// extracted by mini-css-extract-plugin
export var closeButton = "_p-5";
export var container = "_p-0";
export var contentContainer = "_p-1";
export var desktop = "_p-2";
export var fullModalImage = "_p-6";
export var mobile = "_p-3";
export var withImage = "_p-4";